/*
Site Modal
*/

class SiteModal extends HTMLElement {
  constructor() {
    super();
    this._onDocClick = null;
    this._onKeydown = null;
    this._lastFocused = null;
    this.sectionRoot = null;
  }

  connectedCallback() {
    this.sectionRoot = this.closest('[id^="shopify-section-"]') || document;
    this.registerEvents();
    this.modal = this.querySelector(".modal");
  }

  disconnectedCallback() {
    if (this._onDocClick) {
      document.removeEventListener("click", this._onDocClick);
      this._onDocClick = null;
    }
    if (this._onKeydown) {
      document.removeEventListener("keydown", this._onKeydown);
      this._onKeydown = null;
    }
  }

  getFocusableElements() {
    return Array.from(
      this.modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]',
      ),
    ).filter(
      (el) =>
        el.getAttribute("tabindex") !== "-1" && el.getClientRects().length > 0,
    );
  }

  openModal() {
    if (this.modal) {
      this.modal.classList.add("active");
      this._lastFocused = document.activeElement;

      window.setTimeout(() => {
        const focusables = this.getFocusableElements();
        if (focusables.length) focusables[0].focus();
      }, 100);

      if (!this._onKeydown) {
        this._onKeydown = (e) => {
          if (e.key === "Escape") {
            this.closeModal();
            return;
          }
          if (e.key !== "Tab") return;

          const focusables = this.getFocusableElements();
          if (!focusables.length) return;

          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          const active = document.activeElement;

          if (e.shiftKey) {
            if (active === first || !this.modal.contains(active)) {
              e.preventDefault();
              last.focus();
            }
          } else if (active === last || !this.modal.contains(active)) {
            e.preventDefault();
            first.focus();
          }
        };
        document.addEventListener("keydown", this._onKeydown);
      }
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove("active");

      if (this._onKeydown) {
        document.removeEventListener("keydown", this._onKeydown);
        this._onKeydown = null;
      }

      if (this._lastFocused && document.contains(this._lastFocused)) {
        this._lastFocused.focus();
      }
      this._lastFocused = null;
    }
  }

  registerEvents() {
    const opens = this.querySelectorAll(".modal-open");
    const closes = this.querySelectorAll(".modal-close");
    const triggerClass = this.dataset.trigger;

    if (this._onDocClick) {
      document.removeEventListener("click", this._onDocClick);
      this._onDocClick = null;
    }

    if (triggerClass) {
      this._onDocClick = (e) => {
        const button = e.target.closest("button");
        if (!button) return;
        if (this.sectionRoot && !this.sectionRoot.contains(button)) return;
        if (button.matches(triggerClass)) {
          this.openModal();
        }
      };
      document.addEventListener("click", this._onDocClick);
    }

    Array.from(opens).forEach((open) => {
      open.addEventListener("click", (e) => {
        this.openModal();
      });
    });

    Array.from(closes).forEach((close) => {
      close.addEventListener("click", (e) => {
        this.closeModal();
      });
    });
  }
}

customElements.define("site-modal", SiteModal);
